import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL_WEB = `${BaseUrl}auth`;

// const token = localStorage.getItem("token");

export const authLogin = (data) => axios.post(`${API_URL_WEB}/login`, data);

export const validateToken = () => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL_WEB}/profile-by-auth`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}
